var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconCouch = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 41 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.336 21v3.333M36 21v3.333M1 11v6.667C1 19.507 2.49 21 4.333 21H36a3.334 3.334 0 0 0 3.333-3.333V11",
  stroke: "#BDBDBD",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M34.333 11v1.667c0 .918-.746 1.666-1.666 1.666h-25A1.667 1.667 0 0 1 6 12.667V11M36.003 8.604v-.936A6.665 6.665 0 0 0 29.336 1H11.003a6.664 6.664 0 0 0-6.667 6.667v.961",
  stroke: "#BDBDBD",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M1 11c0-1.383 1.118-2.5 2.5-2.5C4.88 8.5 6 9.617 6 11M39.336 11c0-1.383-1.12-2.5-2.5-2.5a2.498 2.498 0 0 0-2.5 2.5M19.336 1v13.333",
  stroke: "#BDBDBD",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

export default SvgIconCouch;